module.exports = __webpack_public_path__ + "static/media/ajuda.fab6be93.png";